import { gql } from '@apollo/client';

export default gql`
  mutation RefundTravelPassVAT($bookingReference: String!, $feeAmount: Float!, $itemRef: String!) {
    refundTravelPassVAT(bookingReference: $bookingReference, itemRef: $itemRef, feeAmount: $feeAmount) {
      reference
      paymentsRefundBalance
      travelPassProducts {
        travelDate
        startDate
        endDate
        name
        code
        price
        currency
        itemRef
        type
        passenger {
          id
          firstName
          lastName
        }
        cancelled
        provisional
        canBeCancelled
        canBeRefunded
        productFamilyId
      }
    }
  }
`;
